import React from 'react'
import { Box, Container, Tab, Tabs, Typography, } from "@mui/material"
import { useState, } from 'react'
import PropTypes from 'prop-types';
import { useTheme } from '@emotion/react'
import HistoricalReport from './HistoricalReport';
import FinalReport from './FinalReport';
import useAuth from '../../hooks/use-auth';
import { ROLE } from '../../constants';
import NeedToBeApprove from './NeedToBeApprove';


const Report = () => {

    const theme = useTheme()
    const [tabValue, setTabValue] = useState(0)
    const { protector } = useAuth()
    function TabPanel(props) {
        const { children, value, index, ...other } = props;

        return (
            <div
                role="tabpanel"
                hidden={value !== index}
                id={`simple-tabpanel-${index}`}
                aria-labelledby={`simple-tab-${index}`}
                {...other}
            >
                {value === index && (
                    <Box sx={{ py: 3 }}>
                        <Typography component={"div"}>{children}</Typography>
                    </Box>
                )}
            </div>
        );
    }


    TabPanel.propTypes = {
        children: PropTypes.node,
        index: PropTypes.number.isRequired,
        value: PropTypes.number.isRequired,
    };

    const handleTabChange = (event, newValue) => {
        setTabValue(newValue);
    };


    return (
        <Box>
            <Container maxWidth="xl">
                <Box sx={{ mb: 2, mt: 3 }}>
                    <Typography sx={{ position: 'relative', pl: 1, fontSize: { xs: 20, md: 22, xl: 25 }, fontWeight: theme.palette.mode === "dark" ? '400' : '500', "&::after": { content: '""', position: 'absolute', background: '#f764a3', width: '3px', left: 0, top: '12.5%', bottom: '12.5%', borderRadius: 1 } }}>Report</Typography>
                </Box>
                <Box>
                    <Box sx={{ width: '100%' }}>
                        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                            <Tabs
                                value={tabValue}
                                onChange={handleTabChange}
                                variant="scrollable"
                                scrollButtons="auto"
                            >
                                <Tab label="Historical Report" />
                                <Tab label="Final Report" />
                                {protector([ROLE.qc]) &&
                                    <Tab label="Need to be approve" />
                                }
                            </Tabs>
                        </Box>
                        <TabPanel value={tabValue} index={0}>
                            <HistoricalReport />
                        </TabPanel>
                        <TabPanel value={tabValue} index={1}>
                            <FinalReport />
                        </TabPanel>
                        {protector([ROLE.qc]) &&
                            <TabPanel value={tabValue} index={2}>
                                <NeedToBeApprove />
                            </TabPanel>
                        }
                    </Box>
                </Box>
            </Container>


        </Box>
    )
}

export default Report